import { useToast } from 'vue-toastification';

export default {
    install: (app) => {
        app.config.globalProperties.$toast = useToast();
    }
};
